import Head from 'next/head';

const PlayerLoadingScripts = () => {
  const playerURL = process.env.NEXT_PUBLIC_PLAYER_URL;
  return (
    <Head>
      {/** If we use <script> tag directly inside <head> next js generates warning.
       * However, moving head to another component resolved it.
       * Ideally, we should have used <Script> tag from next/script but there were 2 issues here.
       * 1. It can not be used with next/head and we wanted our player script in head section.
       * 2. Using next/script tag here is not working. As using that, player bundle is not loading, perhaps dues to internal optimization it does.
       * till we identify it, we are using this workaround of moving next/head to outer component.
       **/}
      <script
        defer
        // src="https://playerscript.zee5.com/zee5Videojs/3.5.2/webPlayer.bundle.js"
        //Uncomment next line for uat-player deployment
        src={playerURL}
      />
      <link
        rel="stylesheet"
        href="https://stcf-prod.zee5.com/prod/zee5Videojs/vcss/video-js.min.css"
      />
      <link
        rel="stylesheet"
        href="https://stcf-prod.zee5.com/prod/zee5Videojs/vcss/videojs.ads.css"
      />
      <link
        rel="stylesheet"
        href="https://stcf-prod.zee5.com/prod/zee5Videojs/vcss/videojs.ima.css"
      />
    </Head>
  );
};

export default PlayerLoadingScripts;
